import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isConfirmValue } from '@app/constants/view-mode';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cancel-download',
  templateUrl: './cancel-download.component.html',
  styleUrls: ['./cancel-download.component.scss']
})
export class CancelDownloadComponent implements OnInit {
  public isTrial = false;
  public chartName = '';
  public isType = 0;
  public isConfirmValue = isConfirmValue;

  constructor(
    public dialogRef: MatDialogRef<CancelDownloadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService,
  ) { }

  ngOnInit() {
    if (this.data && this.data.isTypeConfirm !== null) {
      this.isTrial = true;
      this.isType = this.data.isTypeConfirm;
      if (this.isType === this.isConfirmValue.isTrial) {
        this.translateService.get('TRIAL.CONFIRM_TRIAL', {
          chartName: `<span style="font-weight: bold;">${this.data.name}</span>`
        }).subscribe((value) => {
          this.chartName = value;
        });
      }
    }
  }

  yes() {
    this.dialogRef.close({
      isCancel: true
    });
  }

  no() {
    this.dialogRef.close({
      isCancel: false
    });
  }
}
